import React from 'react'
import posthog from 'posthog-js'

// trackedTitle - format [component][step] action
const TrackableButton = ({ to, children, trackedGroup, trackedTitle, onClick, type = 'button', ...props }) => {

  const handleClick = event => {
    // Prevent default behavior
    event.preventDefault()

    // Track the click event in PostHog
    posthog.capture(trackedTitle, { path: to, group: trackedGroup })

    // Call the onClick prop if it exists
    if (onClick) {
      onClick(event)
    }
  }

  return (
    <button type={type} onClick={handleClick} {...props}>
      {children}
    </button>
  )
}

export default TrackableButton